import { Close16, Close20 } from "@carbon/icons-react";
import { StandardTable, Button, Pagination, Modal } from "react3l-ui-library";
import { useResponsibilityHistoryListHook } from "./ResponsibilityHistoryListHook";
import { MODAL_SIZE } from "react3l-ui-library/build/components/Modal/Modal";
import { Spin, Tabs } from "antd";
import { Tabs as TabsAntd } from "antd";

function ResponsibilityHistoryList() {
    const {
        translate,
        handleGoBack,
        handlePagination,
        requestHistoryList,
        requestHistoryCount,
        rowSelection,
        columns,
        filter,
        dataAppUserGroupingMappingPreview,
        dataRoleMappingPreview,
        columnsModalRoleHistoryPreview,
        columnsModalAppUserGroupingHistoryPreview,
        isVisible,
        handleCloseModal,
        isSpinning,
    } = useResponsibilityHistoryListHook();

    const TabPane = TabsAntd.TabPane;

    return (
        <Spin spinning={isSpinning}>
            <div className="page-content page-content-dxg" id={"page-content-dxg-id"}>
                <div className="info-component ml-4 mb-3">
                    <span>{translate("responsibilities.master.header")}</span>
                    <span> &gt; </span>
                    <span>{translate("responsibilities.master.subHeader")}</span>
                    <span> &gt; </span>
                    <span className="info-primary">
                        {translate("general.actions.listHistory")}
                    </span>
                </div>
                <div className="page page-history mt-0">
                    <div className="pt-3 pb-1 ml-3 d-flex justify-content-between">
                        <h5 className="font-bold page-title">{translate("general.actions.listHistory")}</h5>
                        <div>
                            <Button
                                type="secondary"
                                className="btn--lg btn-red mr-3"
                                icon={<Close16 />}
                                onClick={handleGoBack}
                            >
                                {translate("general.actions.close")}
                            </Button>
                        </div>
                    </div>
                    <div className="page-history__list">
                        <StandardTable
                            rowKey={"versionId"}
                            columns={columns}
                            dataSource={requestHistoryList}
                            tableSize={"md"}
                            rowSelection={rowSelection}
                            bordered
                        />
                        <Pagination
                            skip={filter?.skip}
                            take={filter?.take}
                            total={requestHistoryCount}
                            onChange={handlePagination}
                        />
                    </div>
                </div>

                <Modal
                    size={MODAL_SIZE.SIZE_1200}
                    visible={isVisible === true ? true : false}
                    visibleFooter={true}
                    title={translate("general.history.preview")}
                    handleCancel={handleCloseModal}
                    closable={false}
                    titleButtonCancel={translate("general.actions.close")}
                    titleButtonApply={translate("general.actions.save")}
                    wrapClassName={"dxg-modal-wrap-one-btn"}
                    className="m-t--sm"
                >
                    <Tabs defaultActiveKey={"1"} className="tab-dxg">
                        <TabPane key={"1"} tab={translate("responsibilities.responsibilityRoleMappings")}>
                            <StandardTable
                                rowKey={"id"}
                                columns={columnsModalRoleHistoryPreview}
                                dataSource={dataRoleMappingPreview}
                                tableSize={"md"}
                                bordered={false}
                            />
                        </TabPane>
                        <TabPane key={"2"} tab={translate("responsibilities.listUserGroup.title")}>
                            <StandardTable
                                rowKey={"id"}
                                columns={columnsModalAppUserGroupingHistoryPreview}
                                dataSource={dataAppUserGroupingMappingPreview}
                                tableSize={"md"}
                                bordered={false}
                            />
                        </TabPane>
                    </Tabs>

                    <span className={"close-modal"} onClick={handleCloseModal}>
                        <Close20 />
                    </span>
                </Modal>
            </div>
        </Spin>
    );
}

export default ResponsibilityHistoryList